var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_radial_127_2202)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1005 16C13.5945 16 14.0203 16.3474 14.1196 16.8313L14.6705 19.5173L17.3683 20.0668C17.8529 20.1655 18.201 20.5916 18.201 21.0862C18.201 21.5807 17.8529 22.0068 17.3683 22.1055L14.6705 22.655L14.1196 25.341C14.0203 25.8249 13.5945 26.1723 13.1005 26.1723C12.6065 26.1723 12.1807 25.8249 12.0814 25.341L11.5305 22.655L8.83269 22.1055C8.34812 22.0068 8 21.5807 8 21.0862C8 20.5916 8.34812 20.1655 8.83269 20.0668L11.5305 19.5173L12.0814 16.8313C12.1807 16.3474 12.6065 16 13.1005 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7502 16C35.2442 16 35.6701 16.3474 35.7693 16.8313L36.3203 19.5173L39.0181 20.0668C39.5026 20.1655 39.8507 20.5916 39.8507 21.0862C39.8507 21.5807 39.5026 22.0068 39.0181 22.1055L36.3203 22.655L35.7693 25.341C35.6701 25.8249 35.2442 26.1723 34.7502 26.1723C34.2563 26.1723 33.8304 25.8249 33.7312 25.341L33.1802 22.655L30.4824 22.1055C29.9979 22.0068 29.6497 21.5807 29.6497 21.0862C29.6497 20.5916 29.9979 20.1655 30.4824 20.0668L33.1802 19.5173L33.7312 16.8313C33.8304 16.3474 34.2563 16 34.7502 16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4841 27.0281C18.4841 26.2306 19.1314 25.5846 19.9283 25.5846C20.7251 25.5846 21.3724 26.2306 21.3724 27.0281C21.3724 28.178 22.3065 29.1129 23.462 29.1129C24.6176 29.1129 25.5516 28.178 25.5516 27.0281C25.5516 26.2306 26.1989 25.5846 26.9958 25.5846C27.7926 25.5846 28.4399 26.2306 28.4399 27.0281C28.4399 29.7756 26.2098 32 23.462 32C20.7143 32 18.4841 29.7756 18.4841 27.0281Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1005 16C13.5945 16 14.0203 16.3474 14.1196 16.8313L14.6705 19.5173L17.3683 20.0668C17.8529 20.1655 18.201 20.5916 18.201 21.0862C18.201 21.5807 17.8529 22.0068 17.3683 22.1055L14.6705 22.655L14.1196 25.341C14.0203 25.8249 13.5945 26.1723 13.1005 26.1723C12.6065 26.1723 12.1807 25.8249 12.0814 25.341L11.5305 22.655L8.83269 22.1055C8.34812 22.0068 8 21.5807 8 21.0862C8 20.5916 8.34812 20.1655 8.83269 20.0668L11.5305 19.5173L12.0814 16.8313C12.1807 16.3474 12.6065 16 13.1005 16Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7502 16C35.2442 16 35.6701 16.3474 35.7693 16.8313L36.3203 19.5173L39.0181 20.0668C39.5026 20.1655 39.8507 20.5916 39.8507 21.0862C39.8507 21.5807 39.5026 22.0068 39.0181 22.1055L36.3203 22.655L35.7693 25.341C35.6701 25.8249 35.2442 26.1723 34.7502 26.1723C34.2563 26.1723 33.8304 25.8249 33.7312 25.341L33.1802 22.655L30.4824 22.1055C29.9979 22.0068 29.6497 21.5807 29.6497 21.0862C29.6497 20.5916 29.9979 20.1655 30.4824 20.0668L33.1802 19.5173L33.7312 16.8313C33.8304 16.3474 34.2563 16 34.7502 16Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4841 27.0281C18.4841 26.2306 19.1314 25.5846 19.9283 25.5846C20.7251 25.5846 21.3724 26.2306 21.3724 27.0281C21.3724 28.178 22.3065 29.1129 23.462 29.1129C24.6176 29.1129 25.5516 28.178 25.5516 27.0281C25.5516 26.2306 26.1989 25.5846 26.9958 25.5846C27.7926 25.5846 28.4399 26.2306 28.4399 27.0281C28.4399 29.7756 26.2098 32 23.462 32C20.7143 32 18.4841 29.7756 18.4841 27.0281Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_127_2202",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45) scale(67.8823 37090.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3CF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0420"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar3);
export default __webpack_public_path__ + "static/media/avatar3.49d19ab24a7011e4776cfafaa4f13a88.svg";
export { ForwardRef as ReactComponent };